<template>
  <div>
    <b-form autocomplete="off">
      <b-row>
        <b-col>
          <fccTable
            striped
            hover
            :fields="fieldsArquivos"
            :items="lstArquivos"
            :actions="actionsOutrasFases"
            responsive
            add-filter
            addFunction="addArquivos"
            pdf
            csv
          />
        </b-col>
      </b-row>
    </b-form>
    <fcc-modal
      centered
      id-modal="adicionaArquivos"
      :title-modal="titleModal"
      esconde-footer
      trava-esc
      size="xl"
      trava-back
    >
      <b-form
        autocomplete="off"
        @submit.prevent="arquivo.idoutfasetparq == 0 ? adicionarArquivo() : editarArquivo()"
      >
        <b-row>
          <b-col cols="6">
            <fcc-input v-model="arquivo.tituloarquivo" required>Título</fcc-input>
          </b-col>
          <b-col cols="6">
            <v-select
              v-model="arquivo.extensao"
              :options="lstExtensao"
              multiple
              class="mb-2"
              label="Extensão"
              placeholder="Selecione a Extensão"
              :clearable="false"
              required
            >
              <template #search="{ attributes, events }">
                <input
                  class="vs__search"
                  :required="!arquivo.extensao"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
              <template v-slot:no-options>Nenhum resultado</template>
            </v-select>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col cols="6">
            <fcc-input v-model="arquivo.idexterno" required>Id Externo</fcc-input>
          </b-col>
          <b-col cols="6">
            <fcc-input v-model="arquivo.arqcadcod" required>arqcadcod</fcc-input>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col cols="6">
            <fcc-input v-model="arquivo.qtdemaxima" required type="number"
              >Quantidade Máxima</fcc-input
            >
          </b-col>
          <b-col cols="6">
            <fcc-input v-model="arquivo.qtdeminima" required type="number"
              >Quantidade Minima</fcc-input
            >
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col cols="6"> <toggle-button v-model="arquivo.flvalida" /> Possui função? </b-col>
          <b-col cols="6" v-if="arquivo.flvalida">
            <fcc-select
              :options="lstFuncoes"
              v-model="arquivo.idfuncao"
              required
              labelField="titulofuncao"
              valueField="idfuncao"
              >Função</fcc-select
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <fcc-editor
              v-model="arquivo.descricaoarquivo"
              label="Descrição"
              class="mt-2"
              required
            ></fcc-editor>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col cols="3"><toggle-button v-model="arquivo.podeexcluir" /> Pode Excluir </b-col>
          <b-col cols="3"><toggle-button v-model="arquivo.obrigatorio" /> Obrigatório </b-col>
        </b-row>

        <div class="row innerPage">
          <div class="col-sm-3 ml-auto">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </b-form>
    </fcc-modal>
  </div>
</template>
<script>
import store from '@/store'
import axios from 'axios'

export default {
  data() {
    return {
      lstExtensao: ['.mp4', '.jpeg', '.jpg', '.pdf', '.png'],
      lstFuncoes: [],
      fieldsArquivos: [
        { key: 'tituloarquivo', label: 'Título', sortable: true },
        {
          key: 'obrigatorio',
          label: 'Obrigatório',
          sortable: true,
          type: 'toggle',
          funcaoButton: this.editarStatus,
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          key: 'podeexcluir',
          label: 'Pode Excluir',
          sortable: true,
          type: 'toggle',
          funcaoButton: this.editarStatus,
          objpermCodigo: store.state.permissaoMenu.editar
        },
        { key: 'arqcadcod', label: 'arqcadcod', sortable: true },
        { key: 'qtdemaxima', label: 'Quantidade Máxima', sortable: true },
        { key: 'qtdemaxima', label: 'Quantidade Máxima', sortable: true },
        { key: 'actions', label: '' }
      ],
      lstArquivos: [],
      titleModal: '',
      arquivo: {},
      actionsOutrasFases: [
        {
          button: true,
          funcaoButton: 'editArquivo',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteArquivo',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ]
    }
  },
  props: {
    baseUrlPublicacao: String,
    idPublicacao: Number,
    idoutfase: Number
  },
  mounted() {
    this.listandoArquivos()
    this.validacaoDocumentos().then((res) => {
      this.lstFuncoes = res.data
    })
  },
  methods: {
    deleteArquivo(_, item) {
      this.callConfirm(this.mensagemExcluir, item.tituloarquivo).then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C03'))
          axios
            .delete(
              this.baseUrlPublicacao +
                `PublicacaoOutrasFasesTipoArquivo/ExcluirPublicacaoOutrasFasesTipoArquivo?id=${item.idoutfasetparq}`,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listandoArquivos()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch(this.setErrorSystem)
            .finally(this.carregaTexto)
        }
      })
    },
    editArquivo(_, item) {
      this.titleModal = 'Editar Arquivos'
      this.arquivo = { ...item }
      this.arquivo.extensao = JSON.parse(this.arquivo.extensao)
      this.$root.$emit('bv::show::modal', 'adicionaArquivos')
    },
    editarArquivo() {
      this.arquivo.extensao = JSON.stringify(this.arquivo.extensao)
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          this.baseUrlPublicacao +
            'PublicacaoOutrasFasesTipoArquivo/AlterarPublicacaoOutrasFasesTipoArquivo',
          this.arquivo,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.arquivo = {}
          this.listandoArquivos()
          this.callToast(this.mensagensUpdate.editado, 'success')
          this.$root.$emit('bv::hide::modal', 'adicionaArquivos')
        })
        .catch((error) => {
          this.trataErros(error)
        })
        .finally(this.carregaTexto)
    },
    adicionarArquivo() {
      this.arquivo.idpublicacao = this.idPublicacao
      this.arquivo.idoutfase = this.idoutfase
      this.arquivo.extensao = JSON.stringify(this.arquivo.extensao)
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlPublicacao +
            'PublicacaoOutrasFasesTipoArquivo/InserirPublicacaoOutrasFasesTipoArquivo',
          this.arquivo,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.arquivo = {}
          this.listandoArquivos()
          this.callToast(this.mensagensUpdate.adicionado, 'success')
          this.$root.$emit('bv::hide::modal', 'adicionaArquivos')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    editarStatus(_, item) {
      this.arquivo = item
      this.editarArquivo()
    },
    listandoArquivos() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlPublicacao +
            `PublicacaoOutrasFasesTipoArquivo/ListarPublicacaoOutrasFasesTipoArquivoPorIdOutFase/${this.idoutfase}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstArquivos = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    addArquivos() {
      this.titleModal = 'Adicionar Arquivos'
      this.arquivo = {
        idoutfasetparq: 0,
        qtdemaxima: 1,
        qtdeminima: 1,
        arqcadcod: 'FORMULARIO_DINAMICO'
      }
      this.$root.$emit('bv::show::modal', 'adicionaArquivos')
    }
  }
}
</script>
